// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zoa_","colBig":"styles_colBig__pDyzz","colSmall":"styles_colSmall__1YBJo"};